export default __webpack_public_path__ + "static/media/gordita-bold.b0e7a446.woff2";